import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=74f4bab5&scoped=true"
import script from "./licenses.vue?vue&type=script&lang=js"
export * from "./licenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4bab5",
  null
  
)

export default component.exports